import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class WhatsappUseCase extends BaseUseCase {
    constructor(WhatsappRep) {
        super();
        this.WhatsappRep = WhatsappRep;
    }
    async fetchResult(req) {
        return await this.WhatsappRep.whatsappContentDetailsData(req);
    }
}
export default WhatsappUseCase;
